import actionCreatorFactory from 'common/modules/utils/actionCreatorFactory'

const types = {
    ZOID_INIT: 'ZOID_INIT',
    ZOID_INIT_SUCCESS: 'ZOID_INIT_SUCCESS',
    ZOID_INIT_ERROR: 'ZOID_INIT_ERROR',

    ZOID_CREATE_CHILD: 'ZOID_CREATE_CHILD',
    ZOID_CREATE_CHILD_SUCCESS: 'ZOID_CREATE_CHILD_SUCCESS',
    ZOID_CREATE_CHILD_ERROR: 'ZOID_CREATE_CHILD_ERROR',

    ZOID_ON_PROPS: 'ZOID_ON_PROPS',
}

const creators = {
    init: actionCreatorFactory(types.ZOID_INIT),
    initSuccess: actionCreatorFactory(types.ZOID_INIT_SUCCESS),
    initError: actionCreatorFactory(types.ZOID_INIT_ERROR),
    createChild: actionCreatorFactory(types.ZOID_CREATE_CHILD),
    createChildSuccess: actionCreatorFactory(types.ZOID_CREATE_CHILD_SUCCESS),
    createChildError: actionCreatorFactory(types.ZOID_CREATE_CHILD_ERROR),
    onProps: actionCreatorFactory(types.ZOID_ON_PROPS),
}

export {
    types,
    creators,
}
